"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function GoogleAnalyticsZero() {
    return {
        event: '',
        eventCategory: '',
        eventAction: '',
        eventValue: 0,
    };
}
exports.default = GoogleAnalyticsZero;
